// extracted by mini-css-extract-plugin
export default {"videoEmbed":"_27rXx","player":"_3-qzW","thumbnail":"arghA","overlay":"_1nEU5","button":"_2-AqT","arrow":"_1p4pr","icon":"_2Cohx"};